import { Value } from '../../api/generated'
import React, { FC } from 'react'
import { Accordion, AccordionSummary } from '@mui/material'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import AccordionDetails from '@mui/material/AccordionDetails'
import { Link } from 'react-router-dom'

type RelatedResourceProps = {
  link?: string
  label: string
  items: Value[]
}

export const RelatedResource: FC<RelatedResourceProps> = ({ link = '', label, items = [] }) => {
  const count = items?.length || 0

  return (
    <Accordion>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1-content" id="panel1-header">
        <span style={{marginRight: '0.5rem'}}>{label}:</span><b>{count}</b>
      </AccordionSummary>
      <AccordionDetails>
        {items?.map(({ id, value }, idx) => (
          <div key={id}>
            {idx + 1}.{' '}
            <Link to={`${link}?search=${encodeURIComponent(String(value))}`} target="_blank">
              {value}
            </Link>
          </div>
        ))}
      </AccordionDetails>
    </Accordion>
  )
}
